<template lang="pug">
.recomposicao-table(v-if='recomposicoes.length > 0')
    grid-table-component(:headers='headersRecomposicao', :data='recomposicoes', :is-paginated='false')
        template(v-slot:area='{ item }')
            span {{ item.area | decimal }}

        template(v-slot:sugestaoWebambiente='{ item }')
            .link Ver sugestão

        template(v-slot:validacao='{ item }')
            validacao-component(
                :tipo='item.tipo',
                :item='item',
                :tipos-documentos='tiposDocumentos',
            )
</template>

<script>

import ValidacaoComponent from '@/views/analise/components/ValidacaoComponent.vue';

export default {

    name: 'MraRecuperacaoRegeneracaoTable',

    components: {
        ValidacaoComponent
    },

    props: {
        recomposicoes: {
            type: Array
        },

        tiposDocumentos: {
            type: Array,
            required: true,
        },
    },


    data() {
        return {
            headersRecomposicao: [
                { text: 'Classe', field: 'tipo', width: '50px' },
                { text: 'Área (ha)', field: 'area', width: '50px' },
                // { text: 'Sugestão Webambiente', field: 'sugestaoWebambiente' },
                { text: 'Validação', field: 'validacao', maxWidth: '100px !important' },
            ],
        };
    },
};
</script>

<style lang="sass" scoped>

</style>
